<template>
    <v-form ref="form" v-model="valid">
        <v-row dense>
            <v-col cols="12" sm="10">
                Nombre de Usuario
                <v-text-field
                    v-model="fields.username"
                    :rules="rules.username"
                    :disabled="loading"
                    label="Nombre de Usuario"
                    hide-details="auto"
                    @change="changed('username')"
                    required
                    filled
                    />
            </v-col>
            <v-col cols="12" sm="2">
                <v-card outlined class="pa-1 mt-5 d-flex align-center justify-center">
                    <div class="text-center">
                        <v-switch
                            v-model="fields.is_active"
                            :rules="rules.is_active"
                            :disabled="loading"
                            inset
                            hide-details="auto"
                            color="primary"
                            @change="changed('is_active')"
                            class="ml-4 ma-0"
                            required
                            />
                        <div v-if="fields.is_active">
                            ACTIVO
                        </div>
                        <div v-else>
                            INACTIVO
                        </div>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12">
                Contraseña
                <v-text-field
                    v-model="fields.password"
                    type="password"
                    :rules="rules.password"
                    :disabled="loading"
                    autocomplete="new-password"
                    label="Contraseña"
                    clearable
                    hide-details="auto"
                    @change="changed('password')"
                    filled
                    />
            </v-col>
        </v-row>
    </v-form>
</template>
<script>
import Form from '@mixins/form';

export default {
    mixins: [Form],
    props: ['value', 'loading', 'default'],
    data: function () {
        return {
            defaultFields: {
                username: null,
                password: null,
                is_active: null,
            }
        };
    },
    computed: {
        rules: function () {
            return {
                username: [v => !!v || 'ERROR'],
                password: this.default?.username ? []: [
                    v => !!v || 'ERROR',
                    v => (!!v && v.length >= 6) || 'Mínimo 6 carácteres',
                ],
                is_active: [],
            };
        }
    }
}
</script>